export enum StocksAnalysisTab {
  Analyse = 'Court terme',
}
